import { MATCH_CRITERIA_POPOVER_SHEET_MAX_WIDTH } from './RentalPortalMatchCriteriaPopover.constants'

export function getIsMatchCriteriaPopoverSheet(width) {
  return width <= MATCH_CRITERIA_POPOVER_SHEET_MAX_WIDTH
}
